var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLikeFilled = function SvgLikeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.4c-4.55 0-8.27 3.71-8.27 8.27 0 4.03 2.33 7.72 5.19 10.6 2.85 2.88 6.24 4.99 8.78 5.84 2.54-.85 5.93-2.96 8.78-5.84 2.85-2.88 5.19-6.57 5.19-10.6 0-4.55-3.71-8.27-8.27-8.27-2.42 0-4.49 1.17-6 2.84-1.51-1.67-3.58-2.84-6-2.84z"
  })));
};
export default SvgLikeFilled;